/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState} from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const ChefChatPopup = ({ show, selectedChefData, handleDismiss, handleChefChat }) => {
      const [chatReason, setChatReason] = useState("");
      const [target, setTarget] = useState("");
    
      const handleChefChatReason = (e) => {
        setChatReason(e.target.value);
      };

      const handleTargetChange = (e) => {
        setTarget(e.target.value);
      };

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Initiate Gupshup chat with {selectedChefData.userName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="form-group">
          <label htmlFor="chefChat">Reason to chat</label>
          <textarea
            id="chefChat"
            className="form-control"
            rows="4"
            value={chatReason}
            onChange={handleChefChatReason}
            placeholder="Enter chef chat reason..."
          ></textarea>
        </div>
        <div className="form-group mb-3">
          <label htmlFor="chatTarget">Target</label>
          <select
            id="chatTarget"
            className="form-control"
            value={target}
            onChange={handleTargetChange}
          >
            <option value="" disabled>Select target</option>
            <option value="Supply">Supply</option>
            <option value="Support">Support</option>
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer>
  <button
    type="button"
    className="btn btn-primary"
    onClick={() => {
      handleChefChat({
        chatReason: chatReason,
        target: target
      })
    }}
  >
    Chat
  </button>
  <button
    type="button"
    className="btn btn-secondary"
    data-dismiss="modal"
    onClick={() => handleDismiss()}
  >
    Close
  </button>
</Modal.Footer>

    </Modal>
  );
};

export default ChefChatPopup;
